module.exports = __webpack_public_path__ + "static/media/RDBanner.e4df99db.png";